import { Text } from '@react-pdf/renderer';
import { Nullish } from '@snap-types/types/nullish';

type PartDescriptionProps = {
  description: Nullish<string>;
};

export function PartDescription({ description }: PartDescriptionProps) {
  if (!description) {
    return null;
  }

  return <Text>{description}</Text>;
}
